const PRIMARY_COLOR = '#49028E';
const WHITE = '#FFFFFF';
const BLACK_2 = '#1E1A1B';

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    backgroundColor: WHITE,
    appbarColor: WHITE,
    navbarColor: BLACK_2,
    buttonColor: PRIMARY_COLOR,
    buttonHoverColor: PRIMARY_COLOR,
}

export default lightTheme;